import Swiper, { Navigation, Pagination, Thumbs } from "swiper";

export function sliderThumbs(section, container, controls, sliderOptions, thumbsOptions) {
    const thumbsContainer = section.querySelector(".js-slider-thumbs");
    const defaultSliderOptions = {
        modules: [Navigation, Pagination, Thumbs],
        spaceBetween: 16,
        preventInteractionOnTransition: true,
        observer: true,
        observeParents: true,
        allowTouchMove: false,
    };
    const defaultThumbsOptions = {
        // задается стилями, иначе слайдер будет работать некорректно
        slidesPerView: "auto",
        slidesPerColumn: 1,
        observer: true,
        shortSwipes: false,
        watchOverflow: true,
    };

    if (!controls) {
        console.error(new Error("Элементы управления слайдером не найдены для"), section);
        return;
    }

    if (!thumbsContainer) {
        console.error(
            new Error("Контейнер или переключатели не найдены"),
            "Переключатели:",
            thumbsContainer,
            "Слайдер:",
            container,
        );
        return;
    }

    const serviceThumbs = new Swiper(thumbsContainer, Object.assign(defaultThumbsOptions, thumbsOptions));
    const newSliderOptions = Object.assign(defaultSliderOptions, sliderOptions, {
        navigation: {
            nextEl: controls.buttonNext,
            prevEl: controls.buttonPrev,
        },
        pagination: {
            el: controls.pagination,
            dynamicBullets: true,
            dynamicMainBullets: 3,
            clickable: true,
        },
        thumbs: {
            swiper: serviceThumbs,
        },
        on: {
            touchStart() {
                if (window.mobileMedia) {
                    thumbsContainer.classList.remove("active");
                }
            },
            reachBeginning() {
                serviceThumbs.setProgress(0, 300);
            },
        },
    });

    new Swiper(container, newSliderOptions);

    if (thumbsContainer) {
        document.addEventListener("click", (e) => {
            if (window.mobileMedia) {
                if (!thumbsContainer.contains(e.target)) {
                    thumbsContainer.classList.remove("active");
                }
            }
        });

        thumbsContainer.addEventListener("click", () => {
            if (window.mobileMedia) {
                thumbsContainer.classList.toggle("active");
            }
        });
    }
}